import { StatsigClient, StatsigEvent, StatsigUser } from '@statsig/js-client';
import { useCallback, useEffect, useState } from 'react';
import { configVars } from 'src/helpers';

const client = new StatsigClient(
  configVars.statsig.sdkKey,
  {},
  {
    environment: { tier: configVars.env }
  }
);

// The following IIFE is a workaround to ensure the client is initialized before the app is mounted
// The user is updated on Application.Context.tsx, since is the component with the highest hierarchy
// where the userID, property and company are available
(async () => {
  await client.initializeAsync();
})();

export const useStatsig = () => {
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [isUpdatingConditions, setIsUpdatingConditions] = useState<boolean>(false);
  const [isReady, setIsReady] = useState<boolean>(false);

  useEffect(() => {
    if (!isInitialized) {
      client.initializeAsync();
      setIsInitialized(true);
    }
  }, [isInitialized]);

  useEffect(() => {
    setIsReady(isInitialized && !isUpdatingConditions);
  }, [isInitialized, isUpdatingConditions]);

  const updateUserAsync = useCallback(async (updates: StatsigUser) => {
    setIsUpdatingConditions(true);
    await client.updateUserAsync(updates);
    setIsUpdatingConditions(false);
  }, []);

  const track = useCallback(
    (
      eventOrName: StatsigEvent | string,
      value?: string | number,
      metadata?: Record<string, string>
    ) => {
      client.logEvent(eventOrName, value, metadata);
    },
    []
  );

  return { client, updateUserAsync, isUpdatingConditions, track, isReady };
};
